import LoginType from "../model/LoginType";
import StorageKey from "../model/StorageKey";
import { UnityGameObject, UnityMethod } from "../model/UnityConstant";

export default function SendWalletLoginType(
    unityContext,
    loginType = localStorage.getItem(StorageKey.LONGIN_TYPE)
) {
    // Unity's Client must know the wallet type before it requests SignMessage.
    unityContext.send(
        UnityGameObject.Client,
        UnityMethod.SetIsKubWalletLogin,
        loginType === LoginType.KUB_WALLET ? "true" : "false"
    );
}
